import { call, put, takeLatest } from 'redux-saga/effects';

import { PolicyCommissionInvoiceList, PolicyCommissionInvoice } from '@models/PolicyCommissionInvoice';
import { PolicyCommissionInvoiceApi } from '@apis/PolicyCommissionInvoiceApi';
import { SagaPayload } from '@utils/typescript';
import { Pagination } from '@models/Pagination';

import {
  policyCommissionInvoicesFetch,
  PolicyCommissionInvoicesFetchPayload,
  policyCommissionInvoiceCreate,
  PolicyCommissionInvoiceCreatePayload,
  policyCommissionInvoiceFetch,
  PolicyCommissionInvoiceFetchPayload,
  policyCommissionInvoiceUpdate,
  PolicyCommissionInvoiceUpdatePayload,
  stateUpdate,
  StateUpdatePayload,
  stateReload,
} from './action';

function* handlePolicyCommissionInvoicesFetch({ payload }: SagaPayload<PolicyCommissionInvoicesFetchPayload>) {
  const state: StateUpdatePayload = { invoices: null, pagination: undefined };
  try {
    const [invoices, pagination] = (yield call(PolicyCommissionInvoiceApi.getAll, payload)) as [PolicyCommissionInvoiceList[], Pagination];
    state.invoices = invoices;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePolicyCommissionInvoiceCreate({ payload }: SagaPayload<PolicyCommissionInvoiceCreatePayload>) {
  try {
    yield call(PolicyCommissionInvoiceApi.create, payload);
    yield put(stateReload());
  } catch { }
}

function* handlePolicyCommissionInvoiceFetch({ payload }: SagaPayload<PolicyCommissionInvoiceFetchPayload>) {
  const state: StateUpdatePayload = { invoice: null };
  try {
    state.invoice = (yield call(PolicyCommissionInvoiceApi.get, payload)) as PolicyCommissionInvoice;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePolicyCommissionInvoiceUpdate({ payload }: SagaPayload<PolicyCommissionInvoiceUpdatePayload>) {
  try {
    yield call(PolicyCommissionInvoiceApi.update, payload);
    yield put(stateReload());
  } catch { }
}

export default function* () {
  yield takeLatest(policyCommissionInvoicesFetch, handlePolicyCommissionInvoicesFetch);
  yield takeLatest(policyCommissionInvoiceCreate, handlePolicyCommissionInvoiceCreate);
  yield takeLatest(policyCommissionInvoiceFetch, handlePolicyCommissionInvoiceFetch);
  yield takeLatest(policyCommissionInvoiceUpdate, handlePolicyCommissionInvoiceUpdate);
}
